import { useEffect, useState } from "react";

const champ = { display: "block", width: "100%", padding: 8, boxSizing: "border-box", marginTop: 4 };
const sections = [
  ["Identité société", [
    ["nom_commercial", "Nom commercial / magasin"], ["raison_sociale", "Raison sociale"],
    ["forme_juridique", "Forme juridique"], ["adresse", "Adresse"],
    ["code_postal", "Code postal"], ["ville", "Ville"], ["telephone", "Téléphone"],
    ["email", "Email"], ["siret", "SIRET"], ["tva_intracom", "TVA intracommunautaire"],
    ["logo_devis_path", "Logo (builtin:intersport-clubs ou chemin Storage)"]
  ]],
  ["Informations bancaires", [
    ["titulaire_compte", "Titulaire du compte"], ["iban", "IBAN"], ["bic", "BIC"],
    ["banque", "Banque"], ["instructions_reglement", "Instructions de règlement", true]
  ]],
  ["Messages modèles", [
    ["modele_email_devis", "Message email devis", true],
    ["modele_whatsapp_devis", "Message WhatsApp devis", true]
  ]],
  ["Conditions générales", [
    ["conditions_generales_vente", "CONDITIONS GÉNÉRALES DE VENTE", true]
  ]]
];

export default function ParametresDocumentsGroupe({ clientSupabase, groupe }) {
  const [form, setForm] = useState(null);
  const [message, setMessage] = useState("");
  const [chargement, setChargement] = useState(false);

  useEffect(() => {
    let actif = true;
    (async () => {
      const { data, error } = await clientSupabase.functions.invoke("devis-documents", {
        body: { action: "group-config", groupe }
      });
      if (!actif) return;
      if (error || !data?.configuration) setMessage("Paramètres document indisponibles.");
      else setForm(data.configuration);
    })();
    return () => { actif = false; };
  }, [clientSupabase, groupe]);

  const enregistrer = async () => {
    setChargement(true); setMessage("");
    const { data, error } = await clientSupabase.functions.invoke("devis-documents", {
      body: { action: "save-group-config", groupe, configuration: form }
    });
    setChargement(false);
    setMessage(error || !data?.ok ? "Enregistrement impossible." : "Paramètres devis enregistrés.");
  };

  if (!form) return <section style={{ marginTop: 20 }}><h4>Paramètres devis / contrats</h4><p>{message || "Chargement..."}</p></section>;
  return <section style={{ marginTop: 24, borderTop: "2px solid #1565c0", paddingTop: 16 }}>
    <h4>Paramètres devis / futurs contrats</h4>
    <p><small>Ces valeurs servent de modèle. Elles restent modifiables sur chaque devis sans modifier ce paramétrage.</small></p>
    <div style={{ marginTop: 18 }}>
      <strong>Affichage des remises dans le PDF devis</strong>
      <label style={{ display: "block", maxWidth: 360, marginTop: 8 }}>Format de la remise par ligne
        <select aria-label="Format de la remise par ligne" value={form.affichage_remise_pdf === "VALEUR" ? "VALEUR" : "TAUX"} onChange={(e) => setForm({ ...form, affichage_remise_pdf: e.target.value })} style={champ}>
          <option value="TAUX">Taux (%)</option>
          <option value="VALEUR">Valeur par unité (€)</option>
        </select>
      </label>
    </div>
    {sections.map(([titre, champs]) => <div key={titre} style={{ marginTop: 18 }}>
      <strong>{titre}</strong>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 10, marginTop: 8 }}>
        {champs.map(([cle, libelle, long]) => <label key={cle}>{libelle}{long
          ? <textarea rows="3" value={form[cle] || ""} onChange={(e) => setForm({ ...form, [cle]: e.target.value })} style={champ}/>
          : <input value={form[cle] || ""} onChange={(e) => setForm({ ...form, [cle]: e.target.value })} style={champ}/>}</label>)}
      </div>
    </div>)}
    <button disabled={chargement} onClick={enregistrer} style={{ marginTop: 16, padding: "10px 14px", background: "#1565c0", color: "white", border: 0, borderRadius: 6 }}>ENREGISTRER LES PARAMÈTRES DOCUMENT</button>
    {message && <p>{message}</p>}
  </section>;
}
